"use client"

import { Typography } from "antd";
import { TitleProps } from "antd/es/typography/Title";
import { FC } from "react";

const Title: FC<TitleProps> = (props) => {
  return (
    <Typography.Title {...props} />
  )
}

Title.displayName = 'Title'

export default Title